export enum RemoveMasterListFailure
{
    None = 0,
    Unknown,
    CostCenterAssociation
}